export const dealerLocationFormHeaderOptions = [
  { label: 'Print', value: 'print', callback: 'onClickPrint' },
  { label: 'History', value: 'history', callback: 'onViewHistory' }
];
